// Sources.jsx — v242.47.0 (App Store 1.4.1)
// Style A: tappable authoritative-source chips shown under an AI health answer.
// `sources` is [{ title, url, source }] as returned by the API (MedlinePlus /
// NIH National Library of Medicine). Renders nothing when there are no sources,
// so casual / platform replies show no empty block. NLM asks that we attribute
// to MedlinePlus.gov and not use its logo — hence the plain-text attribution.
import { ExternalLink } from 'lucide-react'
import { useI18n } from '../i18n'

export default function Sources({ sources, className = '' }) {
  const { t } = useI18n()
  if (!Array.isArray(sources) || sources.length === 0) return null

  return (
    <div className={`mt-2 ${className}`}>
      <div className="flex flex-wrap items-center gap-1.5">
        <span className="text-[10px] font-bold uppercase tracking-wide text-[#5B6E80] w-full mb-0.5">
          {t('agent.sources', { defaultValue: 'Sources' })}
        </span>
        {sources.map((s, i) => (
          <a
            key={i}
            href={s.url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 text-[12px] font-semibold text-[#46A8F9] bg-white border border-[#A7D9FC] rounded-full px-2.5 py-1 no-underline active:scale-[0.97] transition-transform"
          >
            <ExternalLink size={12} className="text-[#46A8F9]" strokeWidth={2} />
            <span className="max-w-[180px] truncate">{s.title || s.source || 'MedlinePlus'}</span>
          </a>
        ))}
      </div>
      <p className="text-[10px] text-[#7B8A99] mt-1">
        {t('agent.sourcesAttribution', { defaultValue: 'Health information via MedlinePlus.gov · NIH. Your doctor reviews your case.' })}
      </p>
    </div>
  )
}
